// Loox's dynamic reviews carousel loops by re-showing earlier photos once
// you scroll past the end of the reel — that's expected and left alone.
// The bug this fixes is different: when a product doesn't have many image
// reviews, the same photo sometimes lands in two neighbouring slides, so it
// shows twice side by side in the same view. This only hides a repeat when
// it's within a few slides of its first appearance (i.e. visible together),
// never the distant copy used for the end-of-reel loop.
(function () {
  // How many slides apart still counts as "side by side". Generous enough
  // to cover the widest items-per-view setting in use, far short of the
  // loop clone that sits at the opposite end of the whole slide list.
  var ADJACENCY_WINDOW = 4;

  function dedupeWidget(widget) {
    if (!widget.shadowRoot) return;

    widget.shadowRoot.querySelectorAll('.swiper.image-swiper, .dynamic-carousel-image-swiper-container .swiper').forEach(function (container) {
      var slides = Array.from(container.querySelectorAll('.swiper-slide'));
      var entries = slides.map(function (slide) {
        var img = slide.querySelector('.review-image-wrapper img, img.review-image, img');
        var src = img ? (img.currentSrc || img.src || img.getAttribute('data-src') || '') : '';
        return { slide: slide, key: src.split('?')[0] };
      });

      var changed = false;
      entries.forEach(function (entry, i) {
        if (!entry.key) return;
        // Always start from a clean slate: a slide only stays hidden if we
        // decide again below that it's a near duplicate this pass.
        var wasHidden = entry.slide.style.display === 'none';
        var isNearDuplicate = false;

        for (var j = Math.max(0, i - ADJACENCY_WINDOW); j < i; j++) {
          if (entries[j].key === entry.key) {
            isNearDuplicate = true;
            break;
          }
        }

        entry.slide.style.display = isNearDuplicate ? 'none' : '';
        if (isNearDuplicate !== wasHidden) changed = true;
      });

      if (changed && container.swiper && typeof container.swiper.update === 'function') {
        container.swiper.update();
      }
    });
  }

  function dedupe() {
    document.querySelectorAll('loox-dynamic-carousel-widget').forEach(dedupeWidget);
  }

  // Batch bursts of mutations (lazy-loaded images tend to resolve their
  // src attributes in quick succession) into a single re-check.
  var scheduled = false;
  function scheduleDedupe() {
    if (scheduled) return;
    scheduled = true;
    requestAnimationFrame(function () {
      scheduled = false;
      dedupe();
    });
  }

  function watch() {
    var widgets = document.querySelectorAll('loox-dynamic-carousel-widget');
    if (!widgets.length) return;

    dedupe();

    widgets.forEach(function (widget) {
      if (widget.__glideDedupeObserved || !widget.shadowRoot) return;
      widget.__glideDedupeObserved = true;
      // Watch both new slides being added AND existing <img> tags getting
      // their real src/data-src filled in by Loox's own lazy-loading —
      // the latter is how most slides actually resolve, and a plain
      // childList observer misses it entirely.
      new MutationObserver(scheduleDedupe).observe(widget.shadowRoot, {
        childList: true,
        subtree: true,
        attributes: true,
        attributeFilter: ['src', 'data-src', 'srcset'],
      });
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', watch);
  } else {
    watch();
  }

  // Loox loads its carousel asynchronously, sometimes well after
  // DOMContentLoaded on slower connections. Poll aggressively at first to
  // keep the window where a duplicate could flash on screen as short as
  // possible, then back off once things have settled.
  var attempts = 0;
  var fastInterval = setInterval(function () {
    attempts += 1;
    watch();
    if (attempts >= 20) clearInterval(fastInterval); // ~3s at 150ms
  }, 150);

  var slowAttempts = 0;
  var slowInterval = setInterval(function () {
    slowAttempts += 1;
    watch();
    if (slowAttempts >= 30) clearInterval(slowInterval); // up to ~30s more
  }, 1000);
})();
